// src/normalize-props.ts
import { createNormalizer } from "@zag-js/types";
function toCase(txt) {
  return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
}
var eventMap = {
  htmlFor: "for",
  className: "class",
  onDoubleClick: "onDblclick",
  onChange: "onInput",
  onFocus: "onFocusin",
  onBlur: "onFocusout"
};
function toVueProp(prop) {
  if (prop in eventMap)
    return eventMap[prop];
  if (prop.startsWith("on")) {
    return `on${toCase(prop.substr(2))}`;
  }
  return prop.toLowerCase();
}
var normalizeProps = createNormalizer((props) => {
  const normalized = {};
  for (const key in props) {
    if (key === "children") {
      if (typeof props[key] === "string") {
        normalized["innerHTML"] = props[key];
      } else if (process.env.NODE_ENV !== "production") {
        console.warn("[Vue Normalize Prop] : avoid passing non-primitive value as `children`");
      }
    } else {
      normalized[toVueProp(key)] = props[key];
    }
  }
  return normalized;
});

export {
  normalizeProps
};
